<style lang="scss" scoped>
@media screen and(max-width: 375px) and (min-width: 374px){
  .phone{
    color: #fff;
  }
  .mt30{
    margin-top: 0!important;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .con {
    display: none !important;
  }
  .consult{
    margin-bottom: 0px!important;
  }
  .cons {
    display: block !important;
  }
}

.cons {
  display: none;
}
.consult{
  margin-bottom: -130px;
  position: relative;
  z-index: 2;
  overflow: auto;
  .order{
    background: #F9F9F9 url("../assets/images/order_bg.png") no-repeat;
    li{
      border-bottom:2px solid #fff;
      display: flex;
      align-items: center;
      padding:20px 0;
      &:last-child{
        border: 0;
      }
      label{
        font-size: 20px;
        width:220px;
        color:#fff;
        margin-right: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          margin-right: 8px;
        }
      }
      dl{
        display: flex;
        flex-wrap: wrap;
        flex:1;
        dd{
          width:33%;
          margin:10px 0;
        }
      }
      a{
        color:#333;
      }
      span{
        font-size: 16px;
        font-weight: bold;
        color: #014492;
        text-decoration: underline;
      }
    }
  }
  .order1{
    background: #F9F9F9 url("../assets/img/产品及服务/virus.jpg") no-repeat;
  }
}
@media screen and (max-width: 640px){
  .container{
    width: 90% !important;
    font-size: 14px!important;
  }
  .wrap-tec .c-title{
    padding: 20px 0 20px!important;
    font-size: 20px!important;
  }
  .fb{
    line-height: 25px;
  }
  .consult .order li {
    display: block!important;
  }
  .consult .order li label {
    display: block!important;
    margin-left: 15px;
    text-align: center;
    font-size: 14px!important;
  }
  .consult .order li dl {
    display: block!important;
  }
  .consult .order li span {
    color: #fff;
    font-size: 12px!important;
  }
  .consult .order li dl dd {
    width: 90% !important;
    margin-left: auto;
    color: #fff;
    text-align: center;
    margin-right: auto;
  }
  .consult .order {
    background-size: 100% 100%;
  }
}
.order-form-box {
  font-size: 16px;
  text-align: center;
  a {
    font-weight: bold;
    font-size: 20px;
    color: #13489D;
  }
}
</style>
<template>
  <div class="consult">
    <div class="c-title" v-if="type === 'sanger'">订购与咨询</div>
    <div class="c-title" v-if="type === 'primer'">订购与咨询</div>
    <div class="c-title" v-if="type === 'gene'">订购与咨询<small class="mt10">Ordering and Consulting</small></div>
    <div class="c-title" v-if="type === 'Virus'">服务与咨询<small>Service and Consultation</small></div>
    <div class="c-title" v-if="type === 'Virus1'">服务与咨询<small>Service and Consultation</small></div>
    <div class="c-title" v-if="type === 'Virus2'">服务与咨询<small>Service and Consultation</small></div>
    <div class="c-title" v-if="type === 'orderForm'">服务与咨询<small class="mt20">Ordering and Consultation</small></div>
    <div class="container" v-show="type === 'orderForm'">
      <p class="order-form-box">请下载
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/release/excel/%E5%BF%AB%E9%80%9F%E9%87%8D%E7%BB%84%E6%8A%97%E4%BD%93%E4%B8%8E%E8%9B%8B%E7%99%BD%E8%A1%A8%E8%BE%BE-%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E6%9C%8D%E5%8A%A1%E8%AE%A2%E8%B4%AD%E8%A1%A84.0.xls">订购表</a>
        并发送至邮箱protein@tsingke.com.cn，我们将及时回复您的需求。</p>
    </div>
    <div class="container" v-show="type === 'Virus2'">
      <p class="fb">使用擎科生物的
        <span v-show="type === 'Virus2'" style="color: #014492;" class="pointer" @click="jumps('/tec/order_gene')">在线订购系统</span>
        ，可在线下单，便捷查询合成进度。</p>
      <p class="mt10 fb">如在线订购系统不能满足您的下单需求，请下载
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E8%B4%A8%E7%B2%92%E6%8A%BD%E6%8F%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx">电子订单</a>
        并发送至您临近实验室邮箱，我们将及时回复您的需求。</p>
    </div>
    <div class="container" v-show="type === 'Virus'">
      <p class="fb">使用擎科生物的
        <span v-show="type === 'Virus'" style="color: #014492;" class="pointer" @click="jumps('/tec/order_gene')">在线订购系统</span>
        ，可在线下单，便捷查询合成进度。</p>
      <p class="mt10 fb">如在线订购系统不能满足您的下单需求，请下载
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx">电子订单</a>
        并发送至您临近实验室邮箱，我们将及时回复您的需求。</p>
    </div>
    <div class="container" v-show="type === 'sanger'">
      <p class="fb">使用擎科生物的
        <router-link to="/tec/order_sanger" v-show="type === 'sanger'">在线订购系统</router-link>
        ，可在线下单。</p>
      <p class="mt10 fb">如在线订购系统不能满足您的下单需求，请下载
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E6%B5%8B%E5%BA%8F%E6%A0%B7%E6%9C%AC%E7%99%BB%E8%AE%B0%E5%8D%95.xlsx" v-show="type === 'sanger'">测序样本登记单</a>
        <a href="https://geartest.oss-cn-beijing.aliyuncs.com/tsingke/config/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.docx" v-show="type === 'gene'">电子订单</a>
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%BC%95%E7%89%A9%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx" v-show="type === 'primer'">电子订单</a>
        并发送至您临近实验室邮箱，我们将及时回复您的需求。</p>
    </div>
    <div class="container" v-show="type === 'primer'">
      <p class="fb">使用擎科生物的
        <router-link to="/tec/order_primer" v-show="type === 'primer'">在线订购系统</router-link>
        ，可在线下单，便捷查询合成进度。</p>
      <p class="mt10 fb">如在线订购系统不能满足您的下单需求，请下载
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E4%B8%80%E4%BB%A3%E6%B5%8B%E5%BA%8F%E7%99%BB%E8%AE%B0%E5%8D%95.xlsx" v-show="type === 'sanger'">电子订单</a>
        <a href="https://geartest.oss-cn-beijing.aliyuncs.com/tsingke/config/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.docx" v-show="type === 'gene'">电子订单</a>
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%BC%95%E7%89%A9%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx" v-show="type === 'primer'">电子订单</a>
        并发送至您临近实验室邮箱，我们将及时回复您的需求。</p>
    </div>
    <div class="container" v-show="type === 'gene'">
      <p class="fb">使用擎科生物的
        <router-link to="/tec/order_gene" v-show="type === 'gene'">在线订购系统</router-link>
        ，可在线下单，便捷查询合成进度。</p>
      <p class="mt10 fb">如在线订购系统不能满足您的下单需求，请下载
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E4%B8%80%E4%BB%A3%E6%B5%8B%E5%BA%8F%E7%99%BB%E8%AE%B0%E5%8D%95.xlsx" v-show="type === 'sanger'">电子订单</a>
<!--        <a href="https://geartest.oss-cn-beijing.aliyuncs.com/tsingke/config/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.docx" v-show="type === 'gene'">电子订单</a>-->
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx" v-show="type === 'gene'">电子订单</a>
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%BC%95%E7%89%A9%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx" v-show="type === 'primer'">电子订单</a>
        并发送至您临近实验室邮箱，我们将及时回复您的需求。</p>
    </div>
    <div class="container">
      <ul class="order mt30" v-if="type === 'sanger'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl>
            <dd v-show="type === 'sanger'"><span>400-668-3730 转1</span></dd>
          </dl>
        </li>
        <li>
          <label><img src="@/assets/images/icon_down.png">下载</label>
          <dl>
            <dd v-show="type === 'sanger'">
              <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E6%B5%8B%E5%BA%8F%E6%A0%B7%E6%9C%AC%E7%99%BB%E8%AE%B0%E5%8D%95.xlsx" class="mr30"><span>订单下载</span></a>
              <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/pdf/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E9%80%9A%E7%94%A8%E5%BC%95%E7%89%A9%E5%8F%8A%E5%BA%8F%E5%88%97%E8%A1%A8%E6%A0%BC.pdf"><span>通用引物表下载</span></a>
            </dd>
          </dl>
        </li>
        <li>
          <label v-if="type === 'sanger'"><img src="@/assets/images/icon_email.png">邮箱</label>
          <dl v-if="type === 'sanger'">
            <dd>北京：<span>bj-seq@tsingke.com.cn</span></dd>
            <dd>青岛：<span>qd-seq@tsingke.com.cn</span></dd>
            <dd>南京：<span>nj-seq@tsingke.com.cn</span></dd>
            <dd>上海：<span>sh-seq@tsingke.com.cn</span></dd>
            <dd>杭州：<span>hz-seq@tsingke.com.cn</span></dd>
            <dd>广州：<span>gz-seq@tsingke.com.cn</span></dd>
            <dd>长沙：<span>cs-seq@tsingke.com.cn</span></dd>
            <dd>武汉：<span>wh-seq@tsingke.com.cn</span></dd>
            <dd>西安：<span>xa-seq@tsingke.com.cn</span></dd>
            <dd>郑州：<span>zz-seq@tsingke.com.cn</span></dd>
            <dd>重庆：<span>cq-seq@tsingke.com.cn</span></dd>
            <dd>成都：<span>cd-seq@tsingke.com.cn</span></dd>
            <dd>昆明：<span>km-seq@tsingke.com.cn</span></dd>
          </dl>
        </li>
      </ul>
      <!--RNA合成-->
      <ul class="order mt30" v-if="type === 'rna'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl>
            <dd v-show="type === 'rna'"><span>400-668-3730 转2</span></dd>
          </dl>
        </li>
        <li v-show="type === 'rna'">
          <label><img src="@/assets/images/icon_down.png">下载</label>
          <dl>
            <dd v-show="type === 'rna'">
              <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9RNA%E8%AE%A2%E8%B4%AD%E8%A1%A8_20220801.xlsx"><span>订单下载</span></a>
            </dd>
          </dl>
        </li>
        <li>
          <label v-if="type === 'rna'"><img src="@/assets/images/icon_email.png">邮箱</label>
          <dl v-if="type === 'rna'">
            <dd>北京：<span>bj-synth@tsingke.com.cn</span></dd>
            <!-- <dd>哈尔滨：<span>hrb-synth@tsingke.com.cn</span></dd> -->
            <dd>青岛：<span>qd-synth@tsingke.com.cn</span></dd>
            <dd>南京：<span>nj-synth@tsingke.com.cn</span></dd>
            <dd>上海：<span>sh-synth@tsingke.com.cn</span></dd>
            <dd>杭州：<span>hz-synth@tsingke.com.cn</span></dd>
            <dd>广州：<span>gz-synth@tsingke.com.cn</span></dd>
            <dd>长沙：<span>cs-synth@tsingke.com.cn</span></dd>
            <dd>武汉：<span>wh-synth@tsingke.com.cn</span></dd>
            <dd>西安：<span>xa-synth@tsingke.com.cn</span></dd>
            <dd>郑州：<span>zz-synth@tsingke.com.cn</span></dd>
            <dd>重庆：<span>cq-synth@tsingke.com.cn</span></dd>
            <dd>成都：<span>cd-synth@tsingke.com.cn</span></dd>
            <dd>昆明：<span>km-synth@tsingke.com.cn</span></dd>
            <dd>厦门：<span>xm-synth@tsingke.com.cn</span></dd>
            <dd>南宁：<span>nn-synth@tsingke.com.cn</span></dd>
            <dd>海口：<span>hk-synth@tsingke.com.cn</span></dd>
          </dl>
        </li>
      </ul>
      <!--修饰合成-->
      <ul class="order mt30" v-if="type === 'merging'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl>
            <dd v-show="type === 'merging'"><span>400-668-3730 转4</span></dd>
          </dl>
        </li>
        <li v-show="type === 'merging'">
          <label><img src="@/assets/images/icon_down.png">下载</label>
          <dl>
            <dd v-show="type === 'merging'">
              <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91-%E6%A2%93%E7%86%99%E7%94%9F%E7%89%A9%E4%BF%AE%E9%A5%B0%E5%BC%95%E7%89%A9%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8_20220801.xlsx"><span>订单下载</span></a>
            </dd>
          </dl>
        </li>
        <li>
          <label v-if="type === 'merging'"><img src="@/assets/images/icon_email.png">邮箱</label>
          
          <dl v-if="type === 'merging'">
            <dd>修饰合成部：<span>oligo@tsingke.com.cn</span></dd> 
           <!-- <dd>北京：<span>bj-synth@tsingke.com.cn</span></dd>
            <dd>哈尔滨：<span>hrb-synth@tsingke.com.cn</span></dd> 
            <dd>青岛：<span>qd-synth@tsingke.com.cn</span></dd>
            <dd>南京：<span>nj-synth@tsingke.com.cn</span></dd>
            <dd>上海：<span>sh-synth@tsingke.com.cn</span></dd>
            <dd>杭州：<span>hz-synth@tsingke.com.cn</span></dd>
            <dd>广州：<span>gz-synth@tsingke.com.cn</span></dd>
            <dd>长沙：<span>cs-synth@tsingke.com.cn</span></dd>
            <dd>武汉：<span>wh-synth@tsingke.com.cn</span></dd>
            <dd>西安：<span>xa-synth@tsingke.com.cn</span></dd>
            <dd>郑州：<span>zz-synth@tsingke.com.cn</span></dd>
            <dd>重庆：<span>cq-synth@tsingke.com.cn</span></dd>
            <dd>成都：<span>cd-synth@tsingke.com.cn</span></dd>
            <dd>昆明：<span>km-synth@tsingke.com.cn</span></dd>
            <dd>厦门：<span>xm-synth@tsingke.com.cn</span></dd>
            <dd>南宁：<span>nn-synth@tsingke.com.cn</span></dd>
            <dd>海口：<span>hk-synth@tsingke.com.cn</span></dd>-->
          </dl>
        </li>
      </ul>
      <!-- 常规引物合成 -->
      <ul class="order mt30" v-if="type === 'primer'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl>
            <dd v-show="type === 'primer'"><span>400-668-3730 转2</span></dd>
          </dl>
        </li>
        <li v-show="type === 'primer'">
          <label><img src="@/assets/images/icon_down.png">下载</label>
          <dl>
            <dd v-show="type === 'primer'">
              <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%BC%95%E7%89%A9%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8_20220801.xlsx"><span>订单下载</span></a>
            </dd>
          </dl>
        </li>
        <li>
          <label v-if="type === 'primer'"><img src="@/assets/images/icon_email.png">邮箱</label>
          <dl v-if="type === 'primer'">
            <dd>北京：<span>bj-synth@tsingke.com.cn</span></dd>
            <!-- <dd>哈尔滨：<span>hrb-synth@tsingke.com.cn</span></dd> -->
            <dd>青岛：<span>qd-synth@tsingke.com.cn</span></dd>
            <dd>南京：<span>nj-synth@tsingke.com.cn</span></dd>
            <dd>上海：<span>sh-synth@tsingke.com.cn</span></dd>
            <dd>杭州：<span>hz-synth@tsingke.com.cn</span></dd>
            <dd>广州：<span>gz-synth@tsingke.com.cn</span></dd>
            <dd>长沙：<span>cs-synth@tsingke.com.cn</span></dd>
            <dd>武汉：<span>wh-synth@tsingke.com.cn</span></dd>
            <dd>西安：<span>xa-synth@tsingke.com.cn</span></dd>
            <dd>郑州：<span>zz-synth@tsingke.com.cn</span></dd>
            <dd>重庆：<span>cq-synth@tsingke.com.cn</span></dd>
            <dd>成都：<span>cd-synth@tsingke.com.cn</span></dd>
            <dd>昆明：<span>km-synth@tsingke.com.cn</span></dd>
            <dd>厦门：<span>xm-synth@tsingke.com.cn</span></dd>
            <dd>南宁：<span>nn-synth@tsingke.com.cn</span></dd>
            <dd>海口：<span>hk-synth@tsingke.com.cn</span></dd>
          </dl>
        </li>
      </ul>
      <ul class="order mt30" v-if="type === 'Virus2'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl>
            <dd v-show="type === 'Virus2'"><span>400-668-3730</span></dd>
          </dl>
        </li>
        <li>
          <label><img src="@/assets/images/icon_down.png">下载</label>
          <dl>
            <dd v-show="type === 'Virus2'">
              <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E8%B4%A8%E7%B2%92%E6%8A%BD%E6%8F%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx" class="mr30"><span>订单下载</span></a>
            </dd>
          </dl>
        </li>
        <li>
          <label v-if="type === 'Virus2'"><img src="@/assets/images/icon_email.png">邮箱</label>
          <dl v-if="type === 'Virus2'">
            <dd>北京：<span>gene@tsingke.com.cn</span></dd>
          </dl>
        </li>
      </ul>
      <ul class="order order1 mt30 con" v-if="type === 'Virus'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl style="margin-left: 50px;">
            <dd><span>400-668-3730</span></dd>
          </dl>
        </li>
        <li>
          <label><img src="@/assets/img/zx.png">咨询</label>
          <dl v-if="type === 'Virus'" style="margin-left: 50px;" class="phone">
            点击  <router-link to="/summary/contact" ><span style="color:#014492;font-weight:bold;margin-left: 5px;margin-right: 5px;">联系我们,</span></router-link>获取全国实验室联系方式
          </dl>
        </li>
      </ul>
      <ul class="order order1 mt30 con" v-if="type === 'Virus_cas9'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl style="margin-left: 50px;">
            <dd><span>400-668-3730</span></dd>
          </dl>
        </li>
        <li>
          <label><img src="@/assets/img/zx.png">咨询</label>
          <dl v-if="type === 'Virus_cas9'" style="margin-left: 50px;" class="phone">
            点击  <router-link to="/summary/contact" ><span style="color:#014492;font-weight:bold;margin-left: 5px;margin-right: 5px;">联系我们,</span></router-link>获取全国实验室联系方式
          </dl>
        </li>
      </ul>
      <ul class="order order1 mt50" v-if="type === 'orderForm'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl style="margin-left: 50px;">
            <dd><span>400-668-3730</span></dd>
          </dl>
        </li>
        <li>
          <label><img src="@/assets/img/zx.png">咨询</label>
          <dl style="margin-left: 50px;" class="phone">
            点击  <router-link to="/summary/contact" ><span style="color:#014492;font-weight:bold;margin-left: 5px;margin-right: 5px;">联系我们,</span></router-link>获取全国实验室联系方式
          </dl>
        </li>
      </ul>
      <ul class="order mt30" v-if="type === 'gene'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl>
            <dd v-show="type === 'gene'"><span>400-668-3730</span></dd>
          </dl>
        </li>
        <li>
          <label><img src="@/assets/images/icon_down.png">下载</label>
          <dl>
            <dd v-show="type === 'gene'">
              <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%9F%BA%E5%9B%A0%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8%2020230315.xlsx" class="mr30"><span>订单下载</span></a>
            </dd>
          </dl>
        </li>
        <li>
          <label v-if="type === 'gene'"><img src="@/assets/images/icon_email.png">邮箱</label>
          <dl v-if="type === 'gene'">
            <dd>北京：<span>gene@tsingke.com.cn</span></dd>
          </dl>
        </li>
      </ul>

      <ul class="order order1 mt30 con" v-if="type === 'Virus1'">
        <li>
          <label><img src="@/assets/images/icon_tel.png">电话 </label>
          <dl style="margin-left: 50px;">
            <dd><span>+86-18511598775</span></dd>
          </dl>
        </li>
        <li>
          <label><img src="@/assets/img/zx.png">咨询</label>
          <dl v-if="type === 'Virus1'" style="margin-left: 50px;" class="phone">
            点击  <router-link to="/summary/contact" ><span style="color:#014492;font-weight:bold;margin-left: 5px;margin-right: 5px;">联系我们,</span></router-link>获取全国实验室联系方式
          </dl>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: 'qk-consult',
  props: {
    type: {
      type: String
    }

  },
  methods: {
    jumps(path, name) {
      this.$router.push({ path, params: {name} })
      // 适应新需求，只需要footer中点击scrollTop为0
      window.scrollTo(0, 0)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/consult.vue